import React from "react";
import { grid_images_wrapper } from "../styles/modules/utilities.module.css";

function GridImages({ children }) {
  return <div className={grid_images_wrapper}>{children}</div>;
}

export default GridImages;
